import keyMirror from "ramda-extension/es/keyMirror";
export const specialValidations = keyMirror({
    ACCESSIBLE: null,
    VISIBLE: null
});
export const baseValidationTypes = keyMirror({
    REQUIRED: null,
    ERROR: null,
    WARNING: null,
    UNDERWRITING: null,
    ...specialValidations
});
export const baseValidationPriority = {
    REQUIRED: 0,
    ERROR: 1,
    WARNING: 2
};
export const arrayDeepLevel = keyMirror({
    SAME_INDEX: null,
    PROVIDED_INDEX: null,
    WHOLE: null,
    PARENT_ROW: null,
    TARGET_WHOLE: null
});
export const targetIndicesLevel = keyMirror({
    NESTED: null
});
export const fieldType = keyMirror({
    ARRAY: null,
    FIELD: null,
    FIELD_ARRAY: null
});
export const runType = keyMirror({
    FORM: null,
    FIELD: null,
    FIELD_REGISTRATION: null
});
